export class EquipmentOffering {
    constructor(offer){
        this.equipment_offering_external_id = '';
        this.alliance_external_id = '';
        this.equipment_offering_ref = '';
        this.offering_name = '';
        this.currency = '';
        this.is_dcc = '0';
        this.agreement_length = '';
        this.acquiring_only = '0';
        this.additional_equipment_required = '0';
        this.bundles =  [];
        this.partners = [];
        this.additional_data = [];
        this.bundle_selector = '';
        // this.equipment = [];
        // this.accessory = [];
        // this.online_product = [];
        // this.vas = [];
        // this.bundle = [];
        // this.bundles_list = [];
        if (!!offer) {
            this.setOfferKeys(offer);
        }
    }

    setOfferKeys(offer) {
        let offer_keys = Object.keys(offer);
        offer_keys.map(f => {
            if(f == 'bundles') {
                offer[f].forEach((bundle, index) => {
                    this[f][index] = new Bundle(bundle);
                });
            } else {
                this[f] = offer[f]
            }
        });
    }
}

export class Bundle {
    constructor(bundle) {
        this.equipment_bundle_external_id = '';
        this.bundle_name = '';
        this.bundle_type = '';
        this.individual_item_only = '';
        this.is_boarding_activated = '';
        this.language_code = '';
        this.status = '';
        this.selected = '';
        this.alliance_external_id = '';
        this.bundle_items = [new BundleItem()];
        if (!!bundle) {
            this.setBundle(bundle);
        }
    }

    setBundle(bundle) {
        let bundle_keys = Object.keys(bundle);
        bundle_keys.map(f => {
            if(f == 'bundle_items') {
               this[f] = bundle[f].map((bundle_item, index) => {
                    return new BundleItem(bundle_item);
                });
            } else {
                this[f] = bundle[f]
            }
        });
    }
}

export class BundleItem {
    constructor(bundle) {
        this.equipment_bundle_item_external_id = '';
        this.equipment_bundle_external_id = '';
        this.supplier_code = '';
        this.add_another = '1';
        this.item_type = '';
        this.item_id = '';
        this.equipment_external_id = '';
        this.service_external_id = '';
        // this.features = [];
        // this.feature_selector = '';
        // this.ui_formatted_features = [];
        //this.selected_feature_ids = []; //derived from features. Selected by select2
        //this.value_collect_on_offer_features = []; //derived from features. Used for value collect on offer fill up
        this.slide_index = null;
        this.service = {};
        // this.billing_method_selector = '';
        // this.service_charge_item_selector = '';
        this.billing_methods = [];
        this.service_charges = [];
        this.status = '';
        // this.equipment_list = [];
        // this.item_list = [];
        // this.feature_list = [];
        // this.services_list = [];
        // this.billing_methods_list = [];
        this.billing_plans = [];
        this.equipment = {};
        // this.bundle_items = [];
        this.bundle_name = '';
        this.alliance_external_id = '';
        this.display = true;
        this.default_charge = '';
        this.terminal_quantity = 0;
        this.selected = '';
        this.is_boarding_activated = '';
        if (!!bundle) {
            this.setBundleItem(bundle);
        }
    }
    //
    // getItemName() {
    //     if (this.item_type === 'equipment' || this.item_type === 'accessory') {
    //         return this.equipment.equipment_name;
    //     }
    //     if (this.item_type === 'online_product' || this.item_type === 'vas') {
    //         return this.service.service_name;
    //     }
    //     if (this.item_type === 'bundle') {
    //         return this.bundle_name;
    //     }
    // }

    setBundleItem(bundle) {
        let bundle_keys = Object.keys(bundle);
        bundle_keys.map(f => {
            if(f == 'billing_plans') {
                bundle[f].forEach((bundle_item, index) => {
                    this[f][index] = new BillingMethod(bundle_item);
                });
            } else {
                this[f] = bundle[f]
            }
        });
    }
}

export class BillingMethod {
    constructor(billing_method) {
        this.billing_method_external_id = '';
        this.billing_type_external_id = {};
        this.is_billing_method_group = '';
        this.billing_api_code = '';
        this.billing_method_name = '';
        this.billing_length = '';
        this.minimum_charge = '';
        this.maximum_charge = '';
        this.default_charge = '';
        this.equipment_bundle_item_external_id = '';
        this.alliance_external_id = '';
        this.child_billing_method_external_id = '';
        if (!!billing_method) {
            this.setBillingMethod(billing_method);
        }
    }

    setBillingMethod(billing_method) {
        let billing_method_keys = Object.keys(billing_method);
        billing_method_keys.map(f => {
            this[f] = billing_method[f]
        });
    }
}

export class ServiceCharge {
    constructor(service_charge_item) {
        this.service_charge_item_external_id = '';
        this.selected = '';
        this.service_charge_item = {};
        this.minimum_charge = '';
        this.maximum_charge = '';
        this.default_charge = '';
        this.renewal_minimum_charge = '';
        this.renewal_maximum_charge = '';
        this.renewal_default_charge = '';
        this.item_minimum_charge = '';
        this.item_maximum_charge = '';
        this.item_default_charge = '';
        this.item_renewal_minimum_charge = '';
        this.item_renewal_maximum_charge = '';
        this.item_renewal_default_charge = '';
        this.features = [];
        if (!!service_charge_item) {
            this.setServiceCharge(service_charge_item);
        }
    }

    setServiceCharge(service_charge_item) {
        let service_charge_item_keys = Object.keys(service_charge_item);
        service_charge_item_keys.map(f => {
            this[f] = service_charge_item[f]
        });
    }
}


export class BundleItemFeature {
    constructor(data) {
        this.feature_external_id = '';
        this.feature_name = '';

        this.selected = '';
        this.value = '';

        this.values = [];

        this.control_level_type = '';
        this.control_level_type_external_id = '';
        this.default_value = '';
        this.feature_api_code = '';
        this.feature_input_type = '';
        this.feature_ref = '';
        this.feature_type = '';
        this.is_required = '';
        this.is_visible ='';
        this.is_selectable = '';
        this.max = '';
        this.maximum = '';
        this.min = '';
        this.minimum = '';

        if (!!data) {
            this.setData(data);
        }
    }

    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            this[f] = !!data[f] ? data[f] : '';
        });
    }
}